
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClearDayColour as ObiClearDayColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-clear-day-colour.js';
 
 
 

 
 export const ObiClearDayColour = createComponent({
   react: React,
   tagName: 'obi-clear-day-colour',
   elementClass: ObiClearDayColourElement,
   events: {
     
   }
  });
 
 